import axios from "axios";
import store from "../store/mainStore";
import router from "../router/main-router";
import { encryptStorage } from '../../src/services/encrypt.service';
import { broadcastChannelService } from "../services/broadcast.channel.service";
import UserService from "../services/user.service";
import Swall from 'sweetalert2/dist/sweetalert2.js';
import i18n from '@/helpers/i18n.helper.js';
import i18nService from "../services/i18n.service";

export default function axiosSetup() {
    axios.defaults.baseURL = "/";
    axios.defaults.withCredentials = true;
    axios.interceptors.request.use(
        async config =>{
            const token = encryptStorage.getItem("token");
            if (token) {
                config.headers.Authorization = `Bearer ${token}`;
            }
            const locale =  encryptStorage.getItem(i18nService._selectedLocaleKey);
            if(locale){
                config.headers['Accept-Language'] = locale.code;
            }

            return config;
        },
        error => {
            // Do something with request error
            return Promise.reject(error);
        }
    );

    axios.interceptors.response.use(
        response => {
            return response;
        },
        async error => {
            if (!error.response && store.state.appStore.isInInteractiveMode) {
                if(!store.state.appStore.isInternetConnectionDown){
                    store.commit("setIsInternetConnectionDown", true);
                    console.error(i18n.global.t('com.validation-error.web-error'));
                    store.state.appStore.internetConnectionErrorNotification = Swall.fire({
                        toast: true,
                        position: 'bottom-end',
                        title: i18n.global.t('com.validation-error.no-connection'),
                        html: i18n.global.t('com.validation-error.check-connection'),
                        icon: "error",
                        showConfirmButton: false,
                        showCloseButton: true,
                        didClose: () => {
                            store.commit("setIsInternetConnectionDown", false);
                        }
                    });
                }

                // Zatrzymaj dalsze przetwarzanie i odrzuć obietnicę
                return Promise.reject(error);
            }

            if (error.response != undefined &&
                error.response.config.url !== "Auth/me" &&
                error.response.config.url !== "Auth/login" &&
                error.response.config.url !== "Auth/refresh" &&
                error.response.config.url !== "user/profile" &&
                error.response.config.url !== "Group/people/validate" &&
                error.response &&
                error.response.status !== 404 &&
                error.response.status !== 422)
            {
                store.commit("showError");
            }
            store.commit("hideLoader");

            if (error.response && error.response.status === 401) {
                await UserService.destroyer();
                broadcastChannelService.notifyLogout();
                throw new axios.Cancel(error.response).message.data;
            }

            if (error.response && error.response.status === 403) {
                await router.push({ name: "home" });
            }

            //if (error.response && error.response.status === 422) {
            //    throw new axios.Cancel(error.response).message.data;
            //}

            if (error.response && error.response.status === 500) {

                const server_error_info = i18n.global.t('com.validation-error.server-error-info');
                const server_status_info = i18n.global.t('com.validation-error.server-status-info');
                const server_check = i18n.global.t('com.validation-error.check');

                Swall.fire({
                    title: i18n.global.t('com.validation-error.connection-error'),
                    html: `${server_error_info}<br />${server_check} ${server_status_info}<br /><a href='https://status.esesja.pl/' target="_blank" style="text-decoration: underline;text-transform: uppercase;">${server_status_info}</a>`,
                    icon: "error"
                });
            }

            return Promise.reject(error);
        }
    );
}

// Monitorowanie stanu połączenia
window.addEventListener('online', () => {
    store.commit("setIsInternetConnectionDown", false);
    // Zamknięcie powiadomienia o błędzie (jeśli jest widoczne)
    if (store.state.appStore.internetConnectionErrorNotification) {
        Swall.close(store.state.appStore.internetConnectionErrorNotification);
    }

    if(store.state.appStore.isInInteractiveMode){
        // Wyświetlanie toastu o sukcesie
        Swall.fire({
            toast: true,
            position: 'bottom-end',
            icon: 'success',
            title: i18n.global.t('com.validation-error.connection-back'),
            showConfirmButton: false,
            showCloseButton: true,
            timer: 3000,
            timerProgressBar: true
        });
    }
});
